import { createComponent } from '@carvana/merch-components';
import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import styled from 'styled-components';
import { stickyBannerZIndex } from '~/constants/vdp/zIndex';

export const stickyBannerHeightMobile = 104;
export const stickyBannerHeightDesktop = 116;

export const Wrapper = styled.div.attrs({
  className:
    'bg-white fixed flex justify-between max-w-[1800px] mx-auto px-16 py-16 w-full l:px-32'
})`
  height: ${stickyBannerHeightMobile}px;
  top: ${stickyBannerHeightMobile * -1}px;

  transition: 0.3s top ease-in-out;
  z-index: ${stickyBannerZIndex};

  @media (min-width: ${legacyBreakpoints.m}px) {
    height: ${stickyBannerHeightDesktop}px;
    top: ${stickyBannerHeightDesktop * -1}px;
  }
`;

export const GreyBar = createComponent('div', {
  className: 'h-full border-l border-grey-2'
});

export const FirstColumn = createComponent('div', {
  className: 'flex flex-col text-blue-6'
});

export const YMM = createComponent('div', {
  className: 'mb-4 mt-8 tl-header-s m:tl-header-m'
});

export const SmallPrice = createComponent('div', {
  className: 'flex items-center gap-8 tl-header-xs m:hidden'
});

export const SecondColumn = createComponent('div', {
  className: 'hidden items-center m:flex m:gap-12 l:gap-24'
});

export const MobileShareColumn = createComponent('div', {
  className: 'flex items-start justify-center gap-8 m:hidden'
});

export const BigPrice = createComponent('div', {
  className: 'text-[24px] font-bold leading-[24px] text-blue-6'
});

export const CTAWrapper = createComponent('div', {
  className: 'flex items-center gap-8 m:gap-16'
});
